/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/lucid" */ '@atlassian/logo-third-party/lucid'
		).then((m) => m.LucidIcon),
	{ moduleId: '@atlassian/logo-third-party/lucid' },
);

const LazyLucidIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-lucid" */ './utils').then((m) => m.LucidIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/lucid/icon' },
);

const LazyLucidSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-lucid-search-result" */ './utils').then(
			(m) => m.LucidSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/lucid/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const LucidIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyLucidIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const LucidSearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyLucidSearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
